import React from 'react';

export default ({ title, content, }) => (
  <div>
    <dt className="title">{title}</dt>
    <dd>{content}</dd>
  </div>
);
